import React from "react";
import {Redirect} from "react-router";
import {t} from "../../../i18n";
import {BrandA} from "../../buttons/buttons";


interface Props {
    isIframe:boolean;
    url:string;
    isStore?:boolean;
}

interface State {
    windowOpened: boolean;
    startPlaying:boolean;
}


export default class CoinpaymentsDepositComponent extends React.Component<Props, State>{
    constructor(props:Props) {
        super(props);

        this.state = {windowOpened:false, startPlaying:false};
    }

    onClick = ()=> {
        const h = 750;
        const w = 400;
        const leftPosition = (window.screen.width) ? (window.screen.width-w)/2 : 0;
        const topPosition = (window.screen.height) ? (window.screen.height-h)/2 : 0;
        const settings = 'height='+h+',width='+w+',top='+topPosition+',left='+leftPosition+',scrollbars='+window.scroll+',resizable';

        if(this.state.windowOpened) {
            return this.setState({startPlaying:true});
        } else {
            this.setState({windowOpened:true})
            return window.open(this.props.url,'coinpayments',settings);
        }
    };

    render() {

        if(this.state.startPlaying) {
            return <Redirect to={"/poker"}/>
        }
        if(this.state.windowOpened) {
            return (
                <div className="deposit-container">
                    {this.props && this.props.isStore && <p>{t("payments.method.COINPAYMENTS.purchase_pending")}</p>}
                    {this.props && !this.props.isStore &&  <p>{t("payments.method.COINPAYMENTS.deposit_pending")}</p>}
                    <BrandA onClick={() => this.onClick()} className={"btn btn-cta full-width large"}>Play Now</BrandA>
                </div>
            )
        }
        if(this.props.isIframe && this.props.url) {
            return(
                <div className="deposit-container">
                    {this.props && this.props.isStore && <p>{t("payments.method.COINPAYMENTS.purchase_info")}</p>}
                    {this.props && !this.props.isStore &&  <p>{t("payments.method.COINPAYMENTS.deposit_info")}</p>}
                    <BrandA onClick={() => this.onClick()} className={"btn btn-cta full-width large"}>Open</BrandA>
                </div>
            )
        } else {

            return <div></div>;
        }
    }

}
